import type { CreateIssueParameters } from '@atlassian/jira-business-issue-create/src/types.tsx';
import type { Locale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';
import { DUE_DATE_TYPE, SUMMARY_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { formatTimezonedWithLocale } from '@atlassian/jira-platform-utils-date-fns/src/main.tsx';
import type { Field } from '@atlassian/jira-router-resources-business-configuration/src/types.tsx';
import type { JWMCalendarInlineCreateIssueVariables } from './__generated_apollo__/JWMCalendarInlineCreateIssue';

export const buildInput = (
	input: CreateIssueParameters['input'],
	locale: Locale,
	startDateField: Field | null,
): JWMCalendarInlineCreateIssueVariables['input'] => {
	const singleLineTextFields = [
		{
			fieldId: SUMMARY_TYPE,
			text: input.summary,
		},
	];
	const datePickerFields = [];

	if (input.startDate && startDateField?.id) {
		datePickerFields.push({
			fieldId: startDateField?.id,
			date: {
				formattedDate: formatTimezonedWithLocale(input.startDate, 'dd/MMM/yy', locale, 'UTC'),
			},
		});
	}

	if (input.dueDate) {
		datePickerFields.push({
			fieldId: DUE_DATE_TYPE,
			date: {
				formattedDate: formatTimezonedWithLocale(input.dueDate, 'dd/MMM/yy', locale, 'UTC'),
			},
		});
	}

	const fields = {
		singleLineTextFields,
		datePickerFields,
	};

	const result = {
		projectId: input.projectId,
		issueType: input.issueType.id,
		fields,
	};

	return result;
};
